import { /* delay, */ call, put, select, retry } from 'redux-saga/effects'
import { REQUEST, SUCCESS, FAILED, COMPLETE } from 'crom-api-constants'

import { LOCALE_PREFIX } from './constants'
import { sessionIdSelector } from './selectors'
import fetch from './fetch'
import { createResultAction, takeTypeLatestDebounce } from './helpers/saga'
import { error } from '../toastr'

const requestRegex = new RegExp(`^.*_${REQUEST}$`)

function isRequestAction(_action) {
    return _action.type && requestRegex.test(_action.type)
}

/**
 * Generator for redux-saga for api calls
 * @param {Object} _action - redux action for api call
 */
export function* requestCallSaga(_action) {
    try {
        const skipSessionId = _action?.optional?.skipSessionId ?? false
        const skipHeaders = _action?.optional?.skipHeaders ?? false

        // load needed data
        let sessionId = null
        if (!skipSessionId) {
            sessionId = yield select(sessionIdSelector)
        }

        // prepare header and call request
        const headers = sessionId ? { sid: `gnosus/${sessionId}` } : {}

        // retry is specified
        const _retry = _action?.optional?.retry ?? null // eslint-disable-line no-underscore-dangle

        let result = null
        if (_retry) {
            const maxTries = _retry?.maxTries ?? 1 // how many tries before we dispaych error action
            const delay = _retry?.delay ?? 5000 // delay between tries

            result = yield retry(maxTries, delay, fetch, { headers }, _action.payload, { skipHeaders })
        } else {
            result = yield call(fetch, { headers }, _action.payload, { skipHeaders })
        }

        // test slow requests
        // yield delay(2000);

        // dispatch success action
        yield put(createResultAction(_action, SUCCESS, { response: result }))
    } catch (_err) {
        // dispatch error action
        yield put(createResultAction(_action, FAILED, { error: _err }))

        // show error toast
        if (_err.code === 500) {
            error(
                {
                    id: `${LOCALE_PREFIX}.error.500.text`,
                    values: { url: _err.uri, message: _err.caption },
                },
                `${LOCALE_PREFIX}.error.500.title`,
                {
                    showCloseButton: true,
                    removeOnHover: false,
                    timeOut: 6000,
                }
            )
        }
    } finally {
        // dispatch complete action
        yield put(createResultAction(_action, COMPLETE))
    }
    return null
}

/**
 * Root generator for redux-saga for api calls to run them concurrently
 */
export default function* requestSaga() {
    yield takeTypeLatestDebounce(isRequestAction, requestCallSaga)
}
